import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  overflow: "visible",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.5935 5.95518L13.9997 1L9.45762 3.12971L10.7364 4.00329L8.05404 7.3869L6.99847 6.4804C6.15733 5.75804 4.8802 5.86047 4.16774 6.70743L0.229818 11.3887C-0.121163 11.806 -0.0636919 12.4256 0.358183 12.7727C0.780058 13.1198 1.40658 13.063 1.75756 12.6458L5.69548 7.96447L6.75105 8.87097C7.60931 9.60804 8.91667 9.48429 9.61799 8.5996L12.3745 5.12239L13.5935 5.95518Z",
      fill: "#0C8A65"
    }, null, -1)
  ]))]))
}
export default { render: render }